<svg xmlns="http://www.w3.org/2000/svg" :viewBox="`0 0 ${width} ${height}`" :width="width" :height="height"><slot></slot></svg>